import {useState, useEffect} from 'react';

export function useDebounce(value, delay) {
	const [debounced, setDebounced] = useState(value);

	useEffect(() => {
		const timeout = setTimeout(() => {setDebounced(value)}, delay);

		return () => clearTimeout(timeout);
	}, [value, delay]);

	return debounced;
}

// export default useDebounce;